/*
Jquery Plugin for VideoRecording.
Invoke like a typical Jquery Plugin.
These are the configurable options with the default values.
Override it while creating the plugin or else default values will be picked.

$(document).ready(function() {
      var options = {
        width: "760px",
        height: "428px"
        wmode: "transparent",
        flashSrc:  "core/js/videorecording.swf",
        jQueryDiv: "webcam",
        id: "flashVideo",
        rtmpServer: "localhost",
        debugEnabled: false
      };

      jVid = $("#webcam").JVideo(options);
});

Following events are triggered. Usage documented

1) timerUpdate with seconds remaining as the parameter.

Usage:
$("#webcam").bind("timerUpdate", function(evt, seconds) {
});

2) timerExpired

Usage:
$("#webcam").bind("timerExpired", function(evt, data) {
});

3) recordingStopped

Usage:
$("#webcam").bind("recordingStopped", function(evt, data) {
});

4) Error
Usage:
$("#webcam").bind("recordError", function(evt, data) {
});

*/

// http://www.google.com

(function($) {
  var JVideoPlugin = function(parent, options) {

    var defaults = {
      //Set the Mode for the Stage. Default is transparent.
      wmode: "opaque",
      //Path for the swf Recording File.
      flashSrc: "core/js/videorecording.swf",
      //Jquery Div that the plugin is attached to. Default is webcam
      jQueryDiv: "webcam",
      //ID that needs to be assigned to the Flash Object. Default is flashVideo
      id: "flashVideo",
      //RTMP Server for recording. Default points to dev.
      rtmpServer: "localhost",
      //Enable/Disable Debugging. Default is false. This will enable debug logs from AS.
      debugEnabled: false,
      //Practice or Not
      practice: false,
      //Should always be overwritten
      questionID: "defaultID",
      cameraQuality: "80",
      keyFrameInterval: "40",
      micRate: "11",
      micGain: "50",
      encodeQ: "5",
      framesPerSecond: "30",
      echoSuppression: true
    };

    var JVideo = this;

    JVideo._class = JVideo;
    JVideo.parent = $(parent);
    JVideo.options = $.extend({}, defaults, options);

    JVideo.setupFlash = function() {
      if (!this._class.flashInstance) this._class.flashInstance = [];

      var flashID = this._class.flashInstance.length;
      JVideo._class.flashInstance[flashID] = this;

      JVideo.videoElement = $("<div />");
      JVideo.videoElement.addClass("video");
      JVideo.videoElement.addClass("flash");

      //Using Jquery Flash Plugin.
      JVideo.videoElement.flash({
        id: this.options.id,
        src: this.options.flashSrc,
        wmode: this.options.wmode,
        flashvars: {
          flashID: flashID,
          jQueryDiv: this.options.jQueryDiv,
          rtmpServer: this.options.rtmpServer,
          debugEnabled: this.options.debugEnabled,
          practice: this.options.practice,
          cameraQuality: this.options.cameraQuality,
          keyFrameInterval: this.options.keyFrameInterval,
          micRate: this.options.micRate,
          micGain: this.options.micGain,
          encodeQ: this.options.encodeQ,
          echoSuppression: this.options.echoSuppression,
          framesPerSecond: this.options.framesPerSecond,
          questionID: this.options.questionID
        },
        allowScriptAccess: "always",
        allowFullScreen: true,
        width: this.options.width,
        height: this.options.height
      }, {
        version: 12,
        expressInstall: true
      });

      JVideo.video = this.videoElement.find("embed")[0];

      var divString = "#"+this.options.jQueryDiv;
      if (!JVideo.video) {
        $(divString).trigger('flashNotInstalled');
        throw 'Flash Player not installed';
      } else {
        $(divString).trigger('flashInstalled');
      }

      JVideo.parent.append(JVideo.videoElement);
    };

    JVideo.fixExternalInterface = function() {
      var __flash__addCallback = function(instance, name) {
        instance[name] = function() {
          return eval(instance.CallFunction("<invoke name=\"" + name + "\" returntype=\"javascript\">" + __flash__argumentsToXML(arguments, 0) + "</invoke>"));
        };
      };

      var methods = ["startRecord", "stopRecord"];

      for (var i in methods) {
        __flash__addCallback(this.video, methods[i]);
      }
    };

    JVideo.setupFlash();
    JVideo.fixExternalInterface();


    /**
     * [startRecord description]
     * @param  {String} string
     * @return {void}
     * @Usage
     *        Pass a Javascript object with movieName and duration.
     *  var obj = {
     *     "movieName" : "webcamrecording",
     *     "duration"  : 100
     *  }
     *  jVid.startRecord(obj);
     *
     */
    JVideo.startRecord = function(string) {
      JVideo.video.startRecord(string);
    };

    /**
     * [stopRecord description]
     * @return {[type]}
     */
    JVideo.stopRecord = function() {
      JVideo.video.stopRecord();
    };
  };

  $.fn.JVideo = function(options) {

    return this.each(function() {

      var element = $(this);

      if (element.data('JVideo')) return;

      var jvid = new JVideoPlugin(this, options);

      element.data('JVideo', jvid);
    });
  };
})(jQuery);
